module.exports = __webpack_public_path__ + "static/media/IMG-21.a4e72817.jpg";